import { type FC } from 'react';

interface Props {
  title?: string;
  message?: string;
}

const ErrorMessage: FC<Props> = ({ message = 'Something went wrong', title = 'Error Found' }) => {
  return (
    <div className={'ci:flex ci:flex-col ci:h-full ci:w-full ci:items-center ci:justify-center'}>
      <h1 className={'ci:text-destructive ci:text-xl ci:font-bold'}>{title}</h1>
      <p className={'ci:text-foreground ci:text-base ci:font-medium'}>{message}</p>
    </div>
  );
};
export default ErrorMessage;
